"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var Separator = /** @class */ (function (_super) {
    __extends(Separator, _super);
    function Separator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Separator.prototype.render = function () {
        var _a = this.props, direction = _a.direction, style = _a.style, className = _a.className, attributes = __rest(_a, ["direction", "style", "className"]);
        var isColumn = direction === "column";
        var theme = this.context.theme;
        var styleClasses = theme.prepareStyle({
            style: theme.prefixStyle(__assign({ display: isColumn ? "inline-block" : "block", flex: "0 0 auto", width: isColumn ? 1 : "100%", height: isColumn ? "100%" : 1, background: theme.baseLow, margin: "0 auto" }, style)),
            className: "separator",
            extendsClassName: className
        });
        return (React.createElement("span", __assign({}, attributes, styleClasses)));
    };
    Separator.defaultProps = {
        direction: "row"
    };
    Separator.contextTypes = { theme: PropTypes.object };
    return Separator;
}(React.Component));
exports.Separator = Separator;
exports.default = Separator;
//# sourceMappingURL=index.js.map